/**
 * Maps ChunkType string values to Material Symbol names.
 */
export const chunkTypeIconMap: Record<string, string> = {
  Unknown: 'question_mark',
  Generic: 'article',
  Contact: 'person',
  Address: 'location_on',
  'Transfer Line': 'arrow_right_alt',
  FAQ: 'quiz',
  'Polimorphic Process': 'flowchart',
  'Page Tag': 'label',
  'GIS Layer': 'map',
  Summary: 'auto_awesome',
  Figure: 'image',
  'Meeting Document': 'event_note',
}
